import { connect } from 'react-redux';
import { getAccessories, getAddedProducts, getTreeStructureSettings } from '../../../../../../store/form/selectors';
import NestedAccessoriesTable from './NestedAccessoriesTable';

const mapStateToProps = (state) => ({
  accessories: getAccessories(state),
  treeStructureSettings: getTreeStructureSettings(state),
  addedProducts: getAddedProducts(state),
});

export default connect(mapStateToProps)(NestedAccessoriesTable);
